var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.headless ? _c('v-row', {
    staticClass: "filters"
  }, _vm._l(_vm.fullFiltersConf, function (filterconf) {
    return _c('v-col', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.displayFilter(filterconf) && _vm.shouldDisplayFilter(filterconf),
        expression: "displayFilter(filterconf) && shouldDisplayFilter(filterconf)"
      }],
      key: JSON.stringify(filterconf),
      attrs: {
        "cols": _vm.filterWidth(filterconf),
        "lg": _vm.filterLgWidth(filterconf),
        "md": _vm.filterMdWidth(filterconf),
        "sm": _vm.filterSmWidth(filterconf)
      }
    }, [_c('FiltersItem', {
      attrs: {
        "filter": filterconf,
        "value": _vm.filters ? _vm.filters[filterconf.field] : null,
        "filters": _vm.filters
      },
      on: {
        "change": function change($event) {
          return _vm.filterChanged(filterconf, $event);
        }
      }
    })], 1);
  }), 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }